import type { IProject } from '../../types/global/helper';
import type { StandaloneMediaType } from '../../types/instagramAutomation.types';

export function resolveProjectStandaloneMedia(project?: IProject | null): {
    media_url: string;
    media_type: StandaloneMediaType;
} | null {
    if (!project) return null;

    const media_url =
        (typeof project.project === 'string' && project.project) || project.download_link || project.hls || '';

    if (!media_url) return null;

    const media_type: StandaloneMediaType = project.media_type === 'picture' ? 'image' : 'video';

    return { media_url, media_type };
}
